import { Outlet } from 'react-router-dom';
import { useIsMobile } from '@/hooks/useMediaQuery';
import { useOnlineStatus } from '@/hooks/useOnlineStatus';

export default function AppLayout() {
  const isMobile = useIsMobile();
  const isOnline = useOnlineStatus();
  return (
    <div className="flex h-screen overflow-hidden bg-slate-50">
      <div className="flex flex-1 flex-col overflow-hidden">
        {!isOnline && <div className="flex items-center gap-2 bg-amber-50 px-4 py-2 text-sm text-amber-800">You are offline</div>}
        <main className="flex-1 overflow-y-auto p-4 md:p-6"><Outlet /></main>
      </div>
    </div>
  );
}
